import logo from '../assets/images/logo.svg';

const Logo = () => {
  return <img src={logo} alt='OPD logo' className='logo' />;
};
export default Logo;
